import { useState, useEffect, useCallback, useMemo } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function BaseLayout({ stickyNavbar = false, children }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  // Memoize the handler to prevent unnecessary re-renders
  const handleTabsOrientation = useCallback(() => {
    return window.innerWidth < breakpoints.values.sm
      ? setTabsOrientation("vertical")
      : setTabsOrientation("horizontal");
  }, []);

  useEffect(() => {
    // Add event listener on component mount
    window.addEventListener("resize", handleTabsOrientation);
    
    // Call handler right away to set initial orientation
    handleTabsOrientation();

    // Clean up event listener on component unmount
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [handleTabsOrientation]);

  const handleSetTabValue = useCallback((event, newValue) => {
    setTabValue(newValue);
  }, []);

  // Memoize the content to prevent unnecessary re-renders
  const content = useMemo(() => (
    <SoftBox mt={stickyNavbar ? 3 : 10}>
      {children}
    </SoftBox>
  ), [stickyNavbar, children]);

  return (
    <DashboardLayout>
      <DashboardNavbar absolute={!stickyNavbar} isMini />
      {content}
      <Footer />
    </DashboardLayout>
  );
}

// Typechecking props for BaseLayout
BaseLayout.propTypes = {
  stickyNavbar: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default BaseLayout;
